import { useNavigate } from "react-router-dom";
import WhyChooseUs from "./WhyChooseUs";
import OurProducts from "./OurProducts";
import Projects from "./pages/Projects";
import SolarCalculator from "./SolarCalculator";
import EMICalculator from "./EMICalculator";
import SocialIcons from "./SocialIcons";
import "./index.css";
import bg from "./assets/bg.png";
import "./Home.css";

function Home() {
  const navigate = useNavigate();

  const services = [
    {
      title: "Tata Solar",
      buttons: [
        { text: "On Grid", action: () => window.open("/tata ongrid.pdf", "_blank") },
        { text: "Off Grid", action: () => window.open("/tata-offgrid.pdf", "_blank") },
        { text: "Hybrid", action: () => navigate("/hybrid") },
      ],
    },
    {
      title: "Adani Solar",
      buttons: [
        { text: "On Grid", action: () => window.open("/Adani ongrid.pdf", "_blank") },
        { text: "Off Grid", action: () => navigate("/offgrid") },
        { text: "Hybrid", action: () => navigate("/hybrid") },
      ],
    },
    {
      title: "Solar Atta Chakki",
      buttons: [
        { text: "Click Here", action: () => navigate("/ongrid") },
        
      ],
    },
    {
      title: "Submersible Pumps",
      buttons: [
        { text: "Click Here", action: () => navigate("/ongrid") },
        
      ],
    },
    {
      title: "UTL Solar",
      buttons: [
        { text: "On Grid", action: () => window.open("/UTL ongrid.pdf", "_blank") },
        { text: "Off Grid", action: () => navigate("/offgrid") },
        { text: "Hybrid", action: () => navigate("/hybrid") },
      ],
    },
     {
      title: "Loom Solar                       ",
      buttons: [
        { text: "On Grid", action: () => window.open("/Loom ongrid.pdf", "_blank") },
        { text: "Off Grid", action: () => navigate("/offgrid") },
        { text: "Hybrid", action: () => navigate("/hybrid") },
      ],
    },
  ];

  const feedbacks = [
    {
      img: "/customer1 (1).jpeg",
      name: "Haroon",
      address: "Jhansi, UP",
      text: "Excellent solar installation service. Highly recommended!",
    },
    {
      img: "/customer2.jpeg",
      name: "Akhilesh Chand Srivastava",
      address: "Jhansi, UP",
      text: "Very satisfied with the quality and support.",
    },
    {
      img: "/customer3.jpeg",
      name: "Vijay Laxmi Verma",
      address: "Jhansi, UP",
      text: "Affordable and efficient solar solutions.",
    },
    {
      img: "/customer4.jpeg",
      name: "Amit Kumar",
      address: "Jhansi, UP",
      text: "Professional work and great support after installation.",
    },
    {
      img: "/customer5.jpeg",
      name: "Praveen Kumar",
      address: "Jhansi, UP",
      text: "Affordable and efficient solar solutions.",
    },
    {
      img: "/customer6.jpeg",
      name: "naveen kumar",
      address: "Jhansi, UP",
      text: "Very good service and timely installation.",
    },
    {
      img: "/customer7.jpeg",
      name: "himanshu yadav",
      address: "Jhansi, UP",
      text: "Good quality products and helpful team.",
    },
    {
      img: "/customer8.jpeg",
      name: "Karan Singh",
      address: "Jhansi, UP",
      text: "Electricity bill reduced after solar installation.",
    },
    {
      img: "/customer9.jpeg",
      name: "umesh kumar",
      address: "Jhansi, UP",
      text: "Clean installation and excellent guidance.",
    },
    {
      img: "/customer10.jpeg",
      name: "laxmi verma",
      address: "Jhansi, UP",
      text: "Best solar company for home installation.",
    },
    {
      img: "/customer11.jpeg",
      name: "shivaji kumar",
      address: "Jhansi, UP",
      text: "Reliable service and premium products.",
    },
    {
      img: "/customer12.jpeg",
      name: "om prakash",
      address: "Jhansi, UP",
      text: "Great experience with Solar Wave Technology.",
    },
  ];

  return (
    <div className="home-page">
      <section className="hero-section">
        <video autoPlay muted loop playsInline>
          <source src="/Solar.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <span className="hero-badge">Solar Wave Technology</span>
          <h1>Powering Your Future With Clean Solar Energy</h1>
          <p>
            Smart, reliable, and affordable solar solutions for homes,
            businesses, farms, and industries.
          </p>

          <div className="hero-actions">
            <button onClick={() => navigate("/contact")}>Get Free Consultation</button>
            <button className="outline-btn" onClick={() => navigate("/products")}>
              View Products
            </button>
          </div>
        </div>

        <div className="hero-stats">
          <div>
            <h3>400+</h3>
            <p>Happy Customers</p>
          </div>
          <div>
            <h3>400+</h3>
            <p>Solar Installed</p>
          </div>
          <div>
            <h3>24/7</h3>
            <p>Support</p>
          </div>
        </div>
      </section>

      <section
        className="services-section"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="services-overlay">
          <div className="section-heading">
            <span>Our Services</span>
            <h2>Complete Solar Solutions</h2>
            <p>Choose the right system for your energy needs.</p>
          </div>

          <div className="service-grid">
            {services.map((service, index) => (
              <div className="service-card" key={service.title}>
                <div className="service-number">0{index + 1}</div>
                <h3>{service.title}</h3>
                <div className="service-buttons">
                  {service.buttons.map((button) => (
                    <button key={button.text} onClick={button.action}>
                      {button.text}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="feedback-section">
        <div className="section-heading dark">
          <span>Customer Feedback</span>
          <h2>Trusted By Solar Customers</h2>
          <p>Real experiences from people who switched to solar.</p>
        </div>

        <div className="feedback-container">
          {feedbacks.map((item, index) => (
            <div className="feedback-card" key={index}>
              <img src={item.img} alt={item.name} />
              <h3>{item.name}</h3>
              <p className="address">{item.address}</p>
              <p>"{item.text}"</p>
            </div>
          ))}
        </div>
      </section>

      <WhyChooseUs />
      <OurProducts />
      <Projects />

      <section className="calculator-section-home">
        <div className="section-heading dark">
          <span>Calculate Savings</span>
          <h2>Plan Your Solar Investment</h2>
          <p>Estimate system size, savings, and EMI in seconds.</p>
        </div>

        <div className="calculator-wrapper">
          <div className="calc-box">
            <SolarCalculator />
          </div>

          <div className="calc-box">
            <EMICalculator />
          </div>
        </div>
      </section>

      <SocialIcons />
    </div>
  );
}

export default Home;